import useApi, { ApiOptions } from '../base/useApi';

export interface Params {
  date: Date;
}

export interface Result {}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/user/availability_notification_delay/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: true,
  useGCKey: true,
};

export const useSaveAvailabilityNotificationDelayLazy = (params?: Params) => {
  return useApi<Params, Result>(options, params);
};

export default useSaveAvailabilityNotificationDelayLazy;
